import React from 'react'
import LayerItem from './LayerItem'
import { useDrawing } from '../../context/DrawingContext'
import styles from './LayerPanel.module.css'

const LayerPanel = () => {
  const { state, dispatch } = useDrawing()

  const handleAddLayer = () => {
    dispatch({ type: 'ADD_LAYER' })
  }

  return (
    <div className={styles.layerPanel}>
      <div className={styles.header}>
        <h3 className={styles.title}>레이어</h3>
      </div>

      <div className={styles.layerList}>
        {state.layers.map((layer) => (
          <LayerItem
            key={layer.id}
            layer={layer}
          />
        ))}
      </div>

      <div className={styles.footer}>
        <button 
          className={styles.addLayerButton}
          onClick={handleAddLayer}
        >
          새 레이어 추가
        </button>
      </div>
    </div>
  )
}

export default LayerPanel